import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex"
}
const _hoisted_2 = { class: "span-container" }
const _hoisted_3 = { class: "span-container" }
const _hoisted_4 = { class: "button-modal-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RadioBox = _resolveComponent("RadioBox")!
  const _component_ReglePastille = _resolveComponent("ReglePastille")!
  const _component_SelectSite = _resolveComponent("SelectSite")!
  const _component_ButtonBlue = _resolveComponent("ButtonBlue")!
  const _component_ModalCard = _resolveComponent("ModalCard")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, null, {
    default: _withCtx(() => [
      _createVNode(_component_ModalCard, {
        "active-validate": false,
        headerTitle: _ctx.$t('preventif.suivi.modal.header'),
        "is-pop-up-table": true,
        noPaddingTop: false,
        withoutBotNav: true,
        class: "modal-choix-site",
        onCancel: _ctx.cancel
      }, {
        default: _withCtx(() => [
          (!_ctx.isMultiSite)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", {
                  class: "radio-container",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toogleAllSite(false)))
                }, [
                  _createVNode(_component_RadioBox, {
                    selected: !_ctx.isAllSites
                  }, null, 8, ["selected"]),
                  _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t('preventif.suivi.modal.choix.un')), 1)
                ]),
                _createElementVNode("div", {
                  class: "radio-container",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toogleAllSite(true)))
                }, [
                  _createVNode(_component_RadioBox, { selected: _ctx.isAllSites }, null, 8, ["selected"]),
                  _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('preventif.suivi.modal.choix.tous')), 1)
                ]),
                (_ctx.regleCle)
                  ? (_openBlock(), _createBlock(_component_ReglePastille, {
                      key: 0,
                      cle: _ctx.regleCle
                    }, null, 8, ["cle"]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_SelectSite, {
            "is-multi-site": _ctx.isMultiSite,
            "inclure-termines": _ctx.inclureTermines,
            "selected-sites": _ctx.sites,
            selectedSite: _ctx.site,
            "sites-disabled": _ctx.isAllSites,
            "sites-autorises": _ctx.sitesAutorises,
            title: _ctx.$t('preventif.suivi.modal.recherche.titre'),
            class: "select-site-container",
            onAdd: _ctx.addSite,
            onAddAll: _ctx.addAllSite,
            onPick: _ctx.pick,
            onFilterChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.pick(undefined)))
          }, null, 8, ["is-multi-site", "inclure-termines", "selected-sites", "selectedSite", "sites-disabled", "sites-autorises", "title", "onAdd", "onAddAll", "onPick"]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_ButtonBlue, {
              disabled: _ctx.isMultiSite ? _ctx.sites?.length === 0 : !_ctx.isAllSites && !_ctx.site,
              onClick: _ctx.validerSite,
              text: _ctx.$t('app.bottom.navigation.button.confirm'),
              class: "button-confirm btn",
              name: "confirm"
            }, null, 8, ["disabled", "onClick", "text"])
          ])
        ]),
        _: 1
      }, 8, ["headerTitle", "onCancel"])
    ]),
    _: 1
  }))
}